import { CHANGE_LANGUGAE } from './ApiConstants';
import api from './ApiHandler';

export const editLanguage = async (payload: any) => {
  return await api.post(CHANGE_LANGUGAE, { ...payload });
};
